import { render, staticRenderFns } from "./FileSchoolsFolders.vue?vue&type=template&id=3e03d6c7&scoped=true&"
import script from "./FileSchoolsFolders.vue?vue&type=script&lang=js&"
export * from "./FileSchoolsFolders.vue?vue&type=script&lang=js&"
import style0 from "./FileSchoolsFolders.vue?vue&type=style&index=0&id=3e03d6c7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e03d6c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
